import * as actionTypes from "./actionTypes";

export const hideBottomNav = () => {
  console.log("HERE");

  return {
    type: actionTypes.HIDE_BOTTOMNAV_HOF,
  };
};

export const hideBottomNavDrivers = () => {
  return {
    type: actionTypes.HIDE_BOTTOMNAV_DRIVERS,
  };
};

export const hideBottomNavTeams = () => {
  return {
    type: actionTypes.HIDE_BOTTOMNAV_TEAMS,
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/hide.js